import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root"
})
export class MqService {

  queue = {
    "queue1": {
      executionTime: new Date(),
      messages: []
    }
  };

  constructor() {
  }

  processMessage = async (queueName, msgObj) => {
    if (!this.queue[queueName]) {
      this.queue[queueName] = {messages: [], executionTime: new Date()};
    }

    if (this.queue[queueName].messages.length === 0) {
      await this.processImmediate(msgObj);
    } else {
      this.queue[queueName].messages.push(msgObj);
      await this.processWithDelay(queueName, 2000);
    }
  };

  private processImmediate = (msgObj) => {
    console.log(`Processing message immediately: ${msgObj}`);
    return this.executeMessage(msgObj, 0);
  };

  private processWithDelay = async (queueName: string, initialDelay: number) => {
    while (this.queue[queueName].messages.length > 0) {
      const msgObj = this.queue[queueName].messages.shift();
      const delay = initialDelay - (Date.now() - this.queue[queueName].executionTime); // Calculate delay
      await this.executeMessage(msgObj, delay);
      this.queue[queueName].executionTime = Date.now(); // Update last execution time
    }
  };

  private executeMessage = (msgObj, delay: number) => {
    return new Promise((resolve) => {
      setTimeout(() => {
        console.log(`Processing message: ${msgObj}`);
        resolve(msgObj);
      }, delay);
    });
  };

}
